"use client";

import { c as _c } from "react/compiler-runtime";
import { ServiceVisibilityType } from "@/types/enums/service";
import { PublicServiceAddon, PublicServiceDetail } from "@/types/service";
import { getServicePricingForSelfSchedule } from "./helpers";
import { ServiceMenuItem } from "./service-menu-item";
interface SelectionItemRowProps {
  addon: PublicServiceAddon;
  selected: boolean;
  /** How many times the add-on is picked. */
  count?: number;
  /** Most picks this add-on can reach; omit for no limit. */
  maxQuantity?: number;
  disabled: boolean;
  mode: "radio" | "checkbox";
  onToggle: () => void;
  /** Lets the add-on be picked more than once. Omit to disable repeats. */
  onQuantityChange?: (quantity: number) => void;
  className?: string;
}

/** Adapt a ServiceTiny (addon service) into a PublicServiceDetail for ServiceMenuItem. */
function toServiceDetail(addon: PublicServiceAddon, canRepeat: boolean): PublicServiceDetail {
  const svc = addon.addonService;
  const pricing = getServicePricingForSelfSchedule(svc);
  return {
    ...svc,
    description: svc.description ?? "",
    displayPrice: pricing.displayPrice,
    displayPriceMax: pricing.displayPriceMax,
    estimated: svc.estimated ?? false,
    bookingFee: svc.bookingFee ?? 0,
    providerIds: [],
    locationIds: svc.locationIds ?? [],
    visibility: ServiceVisibilityType.ALL,
    // Drives the menu item's quantity stepper.
    allowMultipleBookings: canRepeat,
    // Nested add-ons aren't supported, so render this service's price on its
    // own — without rolling its own add-ons into a range.
    addons: [],
    selectionMin: undefined,
    selectionMax: undefined
  } as PublicServiceDetail;
}
export const SelectionItemRow = t0 => {
  const $ = _c(26);
  const {
    addon,
    selected,
    count: t1,
    maxQuantity,
    disabled,
    mode,
    className,
    onToggle,
    onQuantityChange
  } = t0;
  const count = t1 === undefined ? selected ? 1 : 0 : t1;
  const canRepeat = addon.addonService.allowMultipleBookings === true && !!onQuantityChange && mode === "checkbox";
  let t2;
  if ($[0] !== addon || $[1] !== canRepeat) {
    t2 = toServiceDetail(addon, canRepeat);
    $[0] = addon;
    $[1] = canRepeat;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const serviceDetail = t2;
  const t3 = mode === "radio" ? "radio" : "checkbox";
  let t4;
  if ($[3] !== disabled || $[4] !== onToggle) {
    t4 = e => {
      if (e.target !== e.currentTarget) {
        return;
      }
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (!disabled) {
          onToggle();
        }
      }
    };
    $[3] = disabled;
    $[4] = onToggle;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onToggle) {
    t5 = () => onToggle();
    $[6] = onToggle;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== canRepeat || $[9] !== onQuantityChange) {
    t6 = canRepeat ? (_, quantity) => onQuantityChange?.(quantity) : undefined;
    $[8] = canRepeat;
    $[9] = onQuantityChange;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== className || $[12] !== count || $[13] !== disabled || $[14] !== maxQuantity || $[15] !== selected || $[16] !== serviceDetail || $[17] !== t5 || $[18] !== t6) {
    t7 = <ServiceMenuItem service={serviceDetail} descriptionDisplay="inline" className={className} isSelected={selected} selectionCount={count} maxQuantity={maxQuantity} disabled={disabled} onServiceClick={t5} onQuantityChange={t6} pricePrefix="+" />;
    $[11] = className;
    $[12] = count;
    $[13] = disabled;
    $[14] = maxQuantity;
    $[15] = selected;
    $[16] = serviceDetail;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== className || $[21] !== selected || $[22] !== t3 || $[23] !== t4 || $[24] !== t7) {
    t8 = <div className={className} role={t3} aria-checked={selected} tabIndex={0} onKeyDown={t4}>{t7}</div>;
    $[20] = className;
    $[21] = selected;
    $[22] = t3;
    $[23] = t4;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};